document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.c-btn[data-component$="-toggle"]');
    const contentSections = document.querySelectorAll('.toggle-panel > div');
    const hiddenContent = document.querySelector('.toggle-panel');

    if (!hiddenContent || !buttons.length || !contentSections.length) {
        return;
    }

    buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const componentAttr = button.dataset.component;
            const targetComponent = componentAttr ? componentAttr.split('-')[0] : null;

            if (!targetComponent) {
                return;
            }

            const isAlreadyActive = button.classList.contains('is-active');

            buttons.forEach((btn) => { btn.classList.remove('is-active'); });
            contentSections.forEach((section) => { section.classList.remove('is-active'); });
            hiddenContent.classList.remove('is-active');

            if (isAlreadyActive) {
                return;
            }

            button.classList.add('is-active');
            const targetSection = document.querySelector(`[data-component="${targetComponent}"]`);

            if (!targetSection) {
                return;
            }

            targetSection.classList.add('is-active');
            hiddenContent.classList.add('is-active');
        });
    });
});
